import { useState, useEffect } from "react";
import fetchAPI from "../../../common/fetchAPI";
import { displayValueForTimeEntry, getTimeFromDecimal } from '../../../common/timesheetFunction';
import { sortData, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';
import { t } from "i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Loader from '../../../common/Loader';

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'FullName'
}

const AssignedProjectTaskTeam = (props: any) => {
    const { AccountProjectTaskId } = props;
    const dispatch = useAppDispatch();
    const { timeEntryFormat } = useAppSelector((state) => state.tasks);
     const { isTimesheetPolicy } = useAppSelector((state) => state.timesheet);
         const { decimalFormat,decimalPlaces,cultureInfoName } = useAppSelector((state) => state.globalState);
    const [teamResponse, setTeamResponse] = useState<any | ''>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
    }

    useEffect(() => {
        renderAssignedProjectTaskTeam();
    }, []);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
        }, 300);

        return () => clearTimeout(handler);
    }, [searchTerm]);

    const renderAssignedProjectTaskTeam = async () => {
        try {
            const response = await fetchAPI(`api/Tasks/GetAssignedAccountProjectTaskEmployeesDetail/${AccountProjectTaskId}`, 'Get', '', true);
            const json = await response.json();
            if (!json[0].hasOwnProperty('Message')) {
                json.map((item: any) => {
                    // item.TotalHours = getTimeFromDecimal(item.TotalHours, timeEntryFormat === 'Time' ? false : true)
                     item.TotalHours = decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalHours, 2) : getTimeFromDecimal(item.TotalHours, false)
                });
                //setTeamResponse(json);
                setTeamResponse(sortData(json, clientSideSorting.sortOrder, clientSideSorting.sortColumn));
            } else {
                setTeamResponse([]);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        let sortedTeamResponse = [...teamResponse];
        setTeamResponse(sortData(sortedTeamResponse, sortOrder, sortColumn));
    }


    const filteredTeam = teamResponse?.filter((item: any) =>
        item.FullName?.toLowerCase().includes(debouncedSearch.toLowerCase())
    );

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Assigned Employee List')} */}
                        {getValueFromResource('Assigned Employee List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={onHandleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                    </div>
                </div>
                {/* <div className='card-body py-3'> */}
                <div className='card-Report-body py-3'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th style={{ width: '80%' }}
                                    // onMouseEnter={() => handleMouseEnter(0)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Employee Name")} */}
                                        {getValueFromResource('Employee Name', dispatch, t)}
                                        {clientSideSorting.sortColumn === 'FullName' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "FullName") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "FullName") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 0 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "FullName") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "FullName") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '20%' }}
                                    // onMouseEnter={() => handleMouseEnter(1)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Total Hours")} */}
                                        {getValueFromResource('Total Hours', dispatch, t)}
                                        {clientSideSorting.sortColumn === 'TotalHours' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalHours") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalHours") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 1 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalHours") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalHours") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTeam?.length > 0 && filteredTeam?.map((item: any) => {
                                    return (
                                        <tr key={item.AccountEmployeeId}>
                                            <td className="tdHeight">
                                                <a className='text-dark d-block'>
                                                    {item.FullName}
                                                </a>
                                            </td>
                                            <td className="tdHeight">
                                                <a className='text-dark fw-bold d-block'>
                                                {item.TotalHours} 
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {filteredTeam?.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AssignedProjectTaskTeam